import millifyFunc from 'millify';

const millify = (value, defaultNullDisplay = '-') => {
  if (!value) {
    return defaultNullDisplay;
  }
  return millifyFunc(value, { units: ['', 'k', 'm', 'b', 't'] });
};

export default millify;
